export default "__VITE_ASSET__v$_GUQg7__"